/**
 * Force Zod jitless mode BEFORE any schema is constructed.
 *
 * Zod v4's object schemas decide at CONSTRUCTION time whether to JIT-compile,
 * and that decision probes `new Function("")`. Under email's generated CSP
 * (public/_headers — script-src without 'unsafe-eval') the probe is caught and
 * Zod falls back to the interpreted parser, so nothing breaks — but the browser
 * still fires a `securitypolicyviolation` ("script-src blocked eval") on every
 * page load, which pollutes the console-health gate and the fleet CSP-report
 * collector. Measured 2026-10-24 on every email route once the CSP was enforced.
 *
 * ES-module imports are hoisted, so this module must be the FIRST import in
 * main.tsx: ESM evaluates imports depth-first in source order, so the config
 * lands before any other email/shared module defines a schema at module scope.
 * Same pattern as ops/ai/data/finance/sms (`src/lib/zod-jitless.ts`).
 *
 * NEVER add 'unsafe-eval' to the CSP to silence this.
 */
import { z } from "zod/v4";

z.config({ jitless: true });

export const ZOD_JITLESS_CONFIGURED = true;
